export default `
# Program
`



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/program/text.js